import React from "react";
import { Link } from "react-router-dom";
interface AddressProps {
  address: string;
  name: string;
  phone: string;
  email: string;
  provinceName: string;
  districtName: string;
  wardName?: string;
}
export const AddressComponent = (props: AddressProps) => {
  const { address, name, phone,email, provinceName, districtName, wardName } = props;
  return (
    address !== null ? (
      <div className="address-container">
        <div className="head p-bot-1 ">
          <span className="text-bold text-black">Địa chỉ giao hàng</span>
          <Link to={`/cart/address`} className="btn btn-cart">
            Chỉnh sửa
          </Link>
        </div>
        <div className="address-container-inner p-2">
          <div className="title text-bold">
            <span className="name">{name}</span>
            <span className="phone">{phone}</span>
          </div>
          <div className="email">
            {email}
          </div>
          <div className="des">
            {`${address}${wardName !== null ?`, ${wardName}`:``}, ${districtName}`}
            <p>{provinceName}</p>
          </div>
        </div>
      </div>
    ): null
  );
};
